import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { PAYMENT_CHECK_INTERVAL, PaymentStatus } from '../../../../../domain/common.model';
import { IOfferService } from '../../../service/ioffer.service';

@Component({
    selector: 'app-return',
    templateUrl: './return.component.html',
    styleUrls: ['./return.component.scss']
})
export class ReturnComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    statuses = PaymentStatus;
    status = PaymentStatus.PENDING;
    orderId: string;

    constructor(private iofferService: IOfferService, private route: ActivatedRoute) {
        this.orderId = this.route.snapshot.params.orderId;
    }

    ngOnInit(): void {
        this.subscriptions.push(
            interval(PAYMENT_CHECK_INTERVAL)
                .subscribe(() => {
                    if (this.status === PaymentStatus.PENDING) {
                        this.iofferService.checkPaymentStatus(this.orderId)
                            .subscribe(payment => this.status = payment.status)
                    }
                })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

}
